import { company } from "./company";
import { moneyInVietnameseWords } from "./moneyInWords";

export type PrintableCashTransaction = {
  number: string;
  transactionType: "Receipt" | "Payment";
  transactionDate: string;
  partnerName?: string | null;
  accountName: string;
  debtNumber?: string | null;
  amount: number;
  bankFee: number;
  reason: string;
  notes?: string | null;
};

const escapeHtml = (value: unknown) => String(value ?? "").replace(/[&<>"']/g, (char) => ({
  "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;"
}[char] ?? char));

export function printCashTransaction(row: PrintableCashTransaction, saveAsPdf = false) {
  const popup = window.open("", "_blank", "width=1000,height=760");
  if (!popup) return;
  const date = new Date(`${row.transactionDate}T00:00:00`).toLocaleDateString("vi-VN");
  const title = row.transactionType === "Receipt" ? "PHIẾU THU" : "PHIẾU CHI";
  popup.document.write(`<!doctype html><html><head><title>${title} ${escapeHtml(row.number)}</title><style>
    @page{size:A4;margin:14mm}*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#172b3d;font-size:14px;margin:0}
    header{text-align:center;border-bottom:2px solid #163f5c;padding-bottom:14px;margin-bottom:20px}header h2{margin:0 0 5px;font-size:18px}header p{margin:3px}
    h1{text-align:center;font-size:25px;margin:18px 0 3px}.number{text-align:center;margin-bottom:24px}.row{display:grid;grid-template-columns:180px 1fr;border-bottom:1px solid #ccd7df;padding:10px 4px}.row span:first-child{color:#5f7280}.amount{font-size:18px;font-weight:700}
    .words{font-style:italic;font-weight:700}.signatures{display:grid;grid-template-columns:repeat(4,1fr);gap:20px;text-align:center;margin-top:55px}.signatures strong{display:block;margin-bottom:65px}.hint{margin-top:30px;color:#6c7e8a;font-size:12px;text-align:center}
  </style></head><body>
    <header><h2>${escapeHtml(company.legalName)}</h2><p>${escapeHtml(company.address)}</p><p>MST: ${escapeHtml(company.taxCode)} · ĐT: ${escapeHtml(company.phone)}</p></header>
    <h1>${title}</h1><div class="number">Số: <strong>${escapeHtml(row.number)}</strong> · Ngày ${escapeHtml(date)}</div>
    <div class="row"><span>Đơn vị / Người nộp nhận</span><strong>${escapeHtml(row.partnerName || "Thu/chi khác")}</strong></div>
    <div class="row"><span>Quỹ / Tài khoản</span><strong>${escapeHtml(row.accountName)}</strong></div>
    <div class="row"><span>Công nợ</span><strong>${escapeHtml(row.debtNumber || "Không liên kết")}</strong></div>
    <div class="row"><span>Lý do</span><strong>${escapeHtml(row.reason)}</strong></div>
    <div class="row"><span>Số tiền</span><span class="amount">${row.amount.toLocaleString("vi-VN")} đồng</span></div>
    <div class="row"><span>Bằng chữ</span><span class="words">${escapeHtml(moneyInVietnameseWords(row.amount))}</span></div>
    <div class="row"><span>Phí ngân hàng</span><strong>${row.bankFee.toLocaleString("vi-VN")} đồng</strong></div>
    ${row.notes ? `<div class="row"><span>Ghi chú</span><span>${escapeHtml(row.notes)}</span></div>` : ""}
    <div class="signatures"><div><strong>Giám đốc</strong>(Ký, họ tên)</div><div><strong>Kế toán trưởng</strong>(Ký, họ tên)</div><div><strong>Người lập phiếu</strong>(Ký, họ tên)</div><div><strong>Người nộp/nhận</strong>(Ký, họ tên)</div></div>
    ${saveAsPdf ? '<p class="hint">Trong cửa sổ in, chọn máy in “Save as PDF / Lưu dưới dạng PDF”.</p>' : ""}
    <script>window.onload=()=>{window.print();}</script></body></html>`);
  popup.document.close();
}
